import { useContext } from "react";
import { DataContext } from "../../../store/data-context";
import styles from "./Section2.module.css";
const Section2 = () => {
  const { section2Data } =
    useContext(DataContext);
  const {
    whyChooseImage,
    headerText,
    paragraphText,
    listItems,
  } = section2Data;

  return (
    <section
      className={styles["main-section__2"]}
    >
      <div
        className={
          styles["main-section__2__image"]
        }
        style={{
          backgroundImage: `url(${whyChooseImage})`,
        }}
      ></div>
      <div
        className={
          styles["main-section__2__text"]
        }
      >
        <h2>{headerText}</h2>
        <p>{paragraphText}</p>
        <p>{paragraphText}</p>
        <ul>
          {listItems.map((item) => {
            return (
              <li key={item.id}>
                <img
                  src={item.icon}
                  alt={item.text}
                />
                <p>{item.text}</p>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Section2;
